import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';

const SIZE = 10;
const RETRY = 3;

@Component({
  selector: 'app-contact-update',
  templateUrl: './contact-update.component.html',
  styleUrls: ['./contact-update.component.css']
})
export class ContactUpdateComponent implements OnInit {

    lambdaMessage: string = "";
    lambdaError: boolean = false;

    showTable: boolean = false;
    tableData: Array<any> = [];

    buttonsDisabled: boolean = true;
    tableButtonsDisabled: boolean = true;
    dataFromFile: boolean = false;

    contactId: string = "";
    contactList: Array<any> = [];

    itemsPerPage: number = 15;
    formValid: boolean = true;

    selectedFile: any = null;
    fileName: string = "";

    showProgressBar: boolean = false;
    contactsReprocessed: number = 0;
    contactsTotal: number = 0;

    constructor(private telecomService: TelecomService) { }

    ngOnInit() {
    }

    reprocessSingleContactRecord(){
        this.dataFromFile = false;
        this.contactList = [];
        this.contactList.push({contactId:this.contactId});
        console.log(this.contactList);
        this.reprocessContactRecords(this.contactList);
    }

    async reprocessBatch(){
        this.tableButtonsDisabled = true;
        this.contactList = [];
        this.contactsTotal = this.tableData.length;
        this.tableData.map(x=>{
            this.contactList.push({contactId: x.contactId});
        });
        this.contactsReprocessed = 0;
        this.showProgressBar = true;
        let chunks = [];
        let consecutiveFailures = 0

        this.lambdaError = false;
        this.lambdaMessage = "Reprocessing contact records. This may take a few minutes.";

        while(this.contactList.length > 0){
            chunks.push(this.contactList.splice(0, SIZE))
        }
        while(chunks.length > 0){
            console.log("chunks remaining: ", chunks.length);
            let success = await this.reprocessContactRecords(chunks[0]);
            if(success){
                this.contactsReprocessed += chunks.splice(0, 1)[0].length;
                consecutiveFailures = 0;
            }else{
                consecutiveFailures ++;
                console.log("consecutive failures: ", consecutiveFailures);
                if(consecutiveFailures > RETRY){
                    this.lambdaError = true;
                    this.lambdaMessage = "Retries Exceeded. Failed to reprocess contacts";
                    break;
                }else{
                    await new Promise(resolve => setTimeout(x=>{resolve}, 1000 * Math.pow(consecutiveFailures, 2)))
                }
            }
        }
        if(chunks.length == 0){
            this.lambdaError = false;
            this.lambdaMessage = "Process completed successfully";
        }
        this.showProgressBar = false;
        this.tableButtonsDisabled = false;
    }

    reprocessContactRecords(list){
        list = list.map(x=>{
            x['contactId'] = x['contactId'].trim();
            return x;
        })
        return new Promise(resolve=>{
            this.buttonsDisabled = true;
            this.lambdaError = false;
            this.lambdaMessage = "";

            // console.log("updating attributes for contactId: ", this.contactId);
            let params = {
                FunctionName: environment.ContactTraceRecordLambdaName,
                Payload: JSON.stringify({
                    operation: 'reprocess',
                    data: list
                })
            }
            console.log(params.Payload);
            this.telecomService.callLambda(params, "An error occurred while retrieving contact records with params: " + params.Payload).then((response:any)=>{
                console.log(response);
                if(response.statusCode == 200){
                    if(!this.dataFromFile){
                        this.lambdaMessage = "Contact records reprocessed successfully";
                        this.buttonsDisabled = false;
                    }
                    resolve(true);
                }else{
                    if(!this.dataFromFile){
                        this.lambdaMessage = "Failed to reprocess contact records";
                        this.lambdaError = true;
                        this.buttonsDisabled = false;
                    }
                    resolve(false);
                }
                
            }, err=> {
                if(!this.dataFromFile){
                    this.lambdaMessage = "Failed to reprocess contact records";
                    this.lambdaError = true
                    this.buttonsDisabled = false;
                }
                resolve(false);
            });
        })
    }

    readSingleContactRecord(){
        this.dataFromFile = false;
        this.contactList = [];
        this.contactList.push({contactId:this.contactId});
        console.log(this.contactList);
        this.readContactRecords().then(()=>{
            this.buttonsDisabled = false;
        });
    }

    readContactRecords(): Promise<any>{
        return new Promise((resolve: any) =>{
            this.showTable = false;
            this.buttonsDisabled = true;
            this.lambdaError = false;
            this.lambdaMessage = "";
            console.log("retreiving attributes for contact list");
            let params = {
                FunctionName: environment.ContactTraceRecordLambdaName,
                Payload: JSON.stringify({
                    operation: 'read',
                    data: this.contactList
                })
            }
            console.log(params.Payload);
            this.telecomService.callLambda(params, "An error occurred while retrieving contact records with params: " + params.Payload).then((data:any)=>{
                if(data.body.Item){
                    this.tableData = data.body.Item;
                    this.showTable = true;
                    resolve()
                }
            },err=>{
                this.lambdaError = true;
                this.lambdaMessage = "Failed to retrieve contact data.";
                this.showTable = false;
                resolve()
            });
        })
    }

    handleEvent(event){
        console.log(event);
        if(event.action === 'put'){
            this.updateSingleRecord(event.item);
        }
    }

    updateSingleRecord(item){
        this.lambdaError = false;
        this.lambdaMessage = "";
        this.buttonsDisabled = true;
        let params = {
            FunctionName: environment.ContactTraceRecordLambdaName,
            Payload: JSON.stringify({
                operation: 'update',
                data: [item]
            })
        }
        console.log(params.Payload);
        this.telecomService.callLambda(params, "An error occurred while retrieving contact records with params: " + params.Payload).then((response:any)=>{
            if(response.statusCode == 200){
                this.lambdaMessage = "Single Contact updated successfully";
                let temp = this.tableData.map(x=>{
                    if(x.contactId === item.contactId){
                        console.log("matching item found");
                        return item;
                    }else{
                        return x;
                    }
                });
                this.tableData = JSON.parse(JSON.stringify(temp));
                if(!this.dataFromFile){
                    this.buttonsDisabled = false;
                }
            }else{
                this.lambdaError = true;
                this.lambdaMessage ="Single Contact update failed";
                if(!this.dataFromFile){
                    this.buttonsDisabled = false;
                }
            }
        }, err=>{
            this.lambdaError = true;
            this.lambdaMessage ="Single Contact update failed";
            if(!this.dataFromFile){
                this.buttonsDisabled = false;
            }
        });
    }

    updateBatch(){
        this.lambdaError = false;
        this.lambdaMessage = "";
        this.tableButtonsDisabled = true;
        let params = {
            FunctionName: environment.ContactTraceRecordLambdaName,
            Payload: JSON.stringify({
                operation: 'update',
                data: this.tableData
            })
        }
        console.log(params.Payload);
        this.telecomService.callLambda(params, "An error occurred while retrieving contact records with params: " + params.Payload).then((response:any)=>{
            if(response.statusCode == 200){
                this.lambdaMessage = "Batch update successful";
                this.tableButtonsDisabled = false;
            }else{
                this.lambdaError = true;
                this.lambdaMessage ="Batch update failed";
                this.tableButtonsDisabled = false;
            }
        }, err=>{
            this.lambdaError = true;
            this.lambdaMessage ="Batch update failed";
            this.tableButtonsDisabled = false;
        });
    }

    validate(){
        if(this.contactId.length > 3){
            this.buttonsDisabled = false;
        }else{
            this.buttonsDisabled = true;
        }
    }

    validateItem(item){
        this.formValid = true;
    }

    includeProperty(attributes, key){
        if(!attributes.hasOwnProperty(key)){
            console.log("Adding missing key: ", key)
            attributes[key] = "";
        }
    }
    removeEmptyProperties(item){
        let keys = Object.keys(item.Attributes);
        keys.map(key=>{
            if(item.Attributes[key] === ""){
                console.log("removing key: ", key)
                delete item.Attributes[key];
            }
        })
        console.log(item);
    }
    getClaim(item){
        if(item.Attributes.hasOwnProperty('claimID')){
            return item.Attributes.claimID;
        }
        return "";
    }
    getStart(item){
        if(item.Attributes.hasOwnProperty('startTime')){
            return item.Attributes.startTime;
        }
        return "";
    }
    getEnd(item){
        if(item.Attributes.hasOwnProperty('endTime')){
            return item.Attributes.endTime;
        }
        return "";
    }
    getAgent(item){
        if(item.Attributes.hasOwnProperty('agentUsername')){
            return item.Attributes.agentUsername;
        }
        return "";
    }

    // batch upload --------------------------------------------------------
    uploadFile($event) {
        this.lambdaError = false;
        this.lambdaMessage = "";
        this.selectedFile = null;
        this.fileName = null;
        this.tableData = [];
        this.showTable = false;
        let csv: string = ""
        this.selectedFile = $event.target.files[0];
        this.fileName = this.selectedFile.name;
        console.log('name: ', this.selectedFile.name);
        console.log('size: ', this.selectedFile.size);
        console.log('type: ', this.selectedFile.type);
        let reader: FileReader = new FileReader();
        reader.readAsText(this.selectedFile);
        reader.onload = (e) => {
            console.log('e: ', e);
            csv = reader.result as string;
            $event.target.value = "";
            let rows = csv.split('\n');
            // handle empty rows
            for(let x=0; x < rows.length; x++){
                if(rows[x].split(',').join('').trim() == ''){
                rows.splice(x, 1); 
                x--;
                }
            }
            if(rows[rows.length -1] === ""){
                rows.pop();
            }
            console.log('rows: ', rows);

            let temp = [];
            rows.map(x=>{
                let data = x.split(",");

                // if attribute is missing (white space), do not put it in the update object
                // this will reprocess but not change the contact attributes

                if(data.length < 5){
                    for(let c= 5-data.length; c > 0; c--){
                        data.push("");
                    }
                }
                let obj = {"contactId": data[0].trim(), "Attributes": {}};
                if(data[1].trim() !== ""){
                    obj.Attributes['claimID'] = data[1].trim()
                }
                if(data[2].trim() !== ""){
                    obj.Attributes['startTime'] = data[2].trim()
                }
                if(data[3].trim() !== ""){
                    obj.Attributes['endTime'] = data[3].trim()
                }
                if(data[4].trim() !== ""){
                    obj.Attributes['agentUsername'] = data[4].trim()
                }
                temp.push(obj);
            });
            this.tableData = JSON.parse(JSON.stringify(temp));
            console.log(this.tableData);
            this.showTable = true;
            this.buttonsDisabled = true;
            this.dataFromFile = true;
            this.tableButtonsDisabled = false;

            // this.contactList = temp;
            // this.readContactRecords().then(()=>{
            //     this.tableButtonsDisabled = false;
            //     this.showTableOptions = true;
            // })
        }
    }
}
